module.exports = __webpack_public_path__ + "img/part3.6ae88544.png";